import { EnrolmentReviewState } from './enrolment-review-state';

export class ReviewReasonSelectionReviewState extends EnrolmentReviewState {
	public display(): void {
		this.review.popups.showReviewReasonSelectionPopup();
	}

	public canPerformNext(): boolean {
		return !!this.review.selectedTriggerPayload.reviewReason;
	}

	public requiresAdditionalInput(): boolean {
		// A single review with nothing further to enrich becomes the terminal, submit-here screen, same as TriggerPayloadReviewState.
		return this.review.enrolments.length !== 1 || this.stillNeedsEnrichment();
	}

	public next(): void {
		if (this.stillNeedsEnrichment()) {
			this.review.transitionTo(this.review.createTriggerPayloadReviewState());
			return;
		}

		this.review.transitionTo(this.review.createTriggerMassReviewConfirmationState());
	}

	private stillNeedsEnrichment(): boolean {
		return (
			this.review.requiresTuitionFee() ||
			this.review.requiresIntakeInformation() ||
			this.review.requiresProgrammeInformation() ||
			this.review.requiresNationality()
		);
	}
}
